import { render, staticRenderFns } from "./sellbooks.vue?vue&type=template&id=2b714d19&"
import script from "./sellbooks.vue?vue&type=script&lang=js&"
export * from "./sellbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports